// extracted by mini-css-extract-plugin
export default {"panel":"DatosGenerales_panel__FqNL-","subHeader":"DatosGenerales_subHeader__Do54i"};